import React from 'react';
import { translate } from '../services';
import { SvgImage } from '.';
import { closeIcon } from '../../style/images';
import { PropTypes } from 'prop-types';

export const TermsOfUseWindow =(props)  => {
  return <div className="termsofuse-window">
      <div className="termsofuse-window-header">
        <div className="termsofuse-window-header-line"></div>
        <span>{ translate('Terms and Conditions') }</span>
        {/* <SvgImage source={ closeIcon } onClick={ props.close }/> */}
      </div>
      <div className="termsofuse-window-content-panel">
        {/* <h4>{ translate( 'Terms of Use') }:</h4> */}
        <span>{ translate( 'Terms of Use Message' ) }</span>
      </div>
      <div className='termsofuse-window-footer'>
        <div className='secondary-button' onClick={props.close}>
          <span>{translate("Okay")}</span>
        </div>
      </div>
    </div>;
}

TermsOfUseWindow.propTypes ={
  hidePopup: PropTypes.func.isRequired
};